   var swiper = new Swiper(".team-slider", {
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
       breakpoints: {
        750: {
          slidesPerView: 2, // Number of slides to show at 1300px and above
          spaceBetween: 30, // Space between slides at 1300px and above
        },
        0: {
          slidesPerView: 1.50, // Number of slides to show at 0px and above
          spaceBetween: 20, // Space between slides at 0px and above
        },
      },
    });